"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jumpApi = _interopRequireWildcard(require("@/api/jumpApi"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      jumpLists: [],
      jumpId: null,
      userType: null,
      customerId: null
    };
  },
  props: {
    value: {
      type: [Number, String]
    }
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.jumpId = val || null;
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
      this.customerId = JavaInfo.customerId;
    } catch (e) {
      this.userType = null;
      this.customerId = null;
    }
    this.remoteMethod();
  },
  methods: {
    throttle: _throttle.default,
    changeSelect: function changeSelect() {
      if (!this.jumpId) {
        this.remoteMethod();
      }
      ;
      this.$emit("input", this.jumpId);
      this.$emit("change", this.jumpId);
    },
    searchBrand: function searchBrand() {
      var _this = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.jumpLists = [];
      var params = {};
      if (Number(this.userType) === 5 && this.customerId) {
        params.customerId = this.customerId;
      }
      jumpApi.selectJumpUrl(keyword, params).then(function (res) {
        _this.jumpLists = (res === null || res === void 0 ? void 0 : res.map(function (item) {
          var _ref = item || {},
            urlType = _ref.urlType,
            urlParam = _ref.urlParam,
            url = _ref.url,
            id = _ref.id;
          var jumpUrl = urlType === 'other' ? url : urlType === 'miniProgram' ? "miniProgram?appId=".concat(urlParam || '') : "".concat(url).concat(urlParam ? "?".concat(urlParam) : '');
          return _objectSpread(_objectSpread({}, item), {}, {
            jumpvalue: "".concat(id, "|&|").concat(jumpUrl)
          });
        })) || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this2 = this;
      this.throttle(function () {
        _this2.searchBrand(data);
      }, 300)();
    },
    remoteMethod: function remoteMethod() {
      this.searchBrand('');
    }
  }
};